import { useRef } from "react";

// Minimum horizontal distance (px) to count as a swipe
const SWIPE_THRESHOLD = 50;
// Maximum vertical drift (px) allowed before we treat it as a scroll, not a swipe
const SWIPE_RESTRAINT = 100;

// Simple touch-swipe detector for lightbox-style photo navigation.
// Spread the returned handlers onto the element that should listen for swipes.
export function useSwipe({ onSwipeLeft, onSwipeRight } = {}) {
  const touchStart = useRef(null);

  function onTouchStart(e) {
    if (e.touches.length !== 1) {
      touchStart.current = null;
      return;
    }
    const t = e.touches[0];
    touchStart.current = { x: t.clientX, y: t.clientY };
  }

  function onTouchEnd(e) {
    const start = touchStart.current;
    touchStart.current = null;
    if (!start) return;

    const t = e.changedTouches[0];
    const dx = t.clientX - start.x;
    const dy = t.clientY - start.y;

    if (Math.abs(dx) < SWIPE_THRESHOLD) return;
    if (Math.abs(dy) > SWIPE_RESTRAINT) return;

    if (dx < 0) onSwipeLeft && onSwipeLeft();
    else onSwipeRight && onSwipeRight();
  }

  function onTouchCancel() {
    touchStart.current = null;
  }

  return { onTouchStart, onTouchEnd, onTouchCancel };
}

export default useSwipe;
